import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { Me, User } from '../../models/User'
import type { BaseRequest, BaseResponse } from '../models'
import { readToken } from '../token/token'

// Define a service using a base URL and expected endpoints
const _BASE_URL = import.meta.env.REACT_APP_IAM_API_BASE_URL!

export const userApi = createApi({
  reducerPath: 'userApi',
  baseQuery: fetchBaseQuery({
    baseUrl: _BASE_URL,
    prepareHeaders: (headers) => {
      const token = readToken()
      if (token) {
        headers.set('Authorization', `Bearer ${token.accessToken}`)
      }
      return headers
    },
  }),
  tagTypes: ['me'],
  endpoints: (builder) => ({
    getMe: builder.query<Me, BaseRequest>({
      query: (request) => `/accounts/${request.accountId}/users/me`,
      transformResponse: (response: BaseResponse<User>) => {
        return {
          ...response.data,
          me:
            response.data.firstName && response.data.lastName
              ? `${response.data.firstName} ${response.data.lastName}`
              : response.data.name
              ? response.data.name
              : response.data.username,
        }
      },
      providesTags: ['me'],
    }),

    getUserHash: builder.query<string, BaseRequest>({
      query: (request) => ({
        url: `/accounts/${request.accountId}/users/me/hash`,
        method: 'POST',
      }),
      transformResponse: (response: BaseResponse<string>) => {
        return response.data
      },
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useLazyGetMeQuery, useLazyGetUserHashQuery } = userApi
